import { render, staticRenderFns } from "./ColumnsEffect.vue?vue&type=template&id=90a17f14&"
import script from "./ColumnsEffect.vue?vue&type=script&lang=js&"
export * from "./ColumnsEffect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports